import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import PurchaseHistoryOrderCodesItem from "./PurchaseHistoryOrderCodesItem";
import OrderCodesItem from "./CurrentOrderCodesItem";

interface PurchaseHistoryOrderCodesListProps {
    userOrderData: any;
    handleSelectCategory: (category: string) => void;
    selectedCategoryProps: string;
}

const PurchaseHistoryOrderCodesList = (props: PurchaseHistoryOrderCodesListProps) => {
    const { category } = useParams();
    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState<string>(props.selectedCategoryProps);
    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 10;
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;

    const scrollToTop = () => {
        window.scrollTo({ top: 187, behavior: 'smooth' });
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    }

    useEffect(() => {
        navigate(`/my-codes/purchase-history/${selectedCategory.toLowerCase().replace(/\s/g, "-")}`);
    }, []);

    const renderProductByCategory = () => {
        const filterProductsByCategory = selectedCategory === "All" ? props.userOrderData : props.userOrderData.filter((item: any) => item?.takeOutAdId?.tags[0] === selectedCategory);
        const mergedData: any[] = [];
        filterProductsByCategory?.forEach((item: any) => {
            mergedData.push(item);
        });

        const paginatedData = mergedData.slice(startIndex, endIndex);
        const totalPages = Math.ceil(mergedData.length / ITEMS_PER_PAGE);

        /*
                    <div className="purchaseHistoryOrderCodesList__container-wrap-map">
                <div className="purchaseHistoryOrderCodesList__container-items-wrap">
                    {
                        paginatedData.map((item: any, index: number) => {
                            return (
                                <div
                                    style={{
                                        marginTop: "20px",//(index + 1) % 5 !== 0 ? "20px" : "0",
                                        //marginLeft: (index + 1) % 5 !== 1 ? "30px" : "0",
                                        marginRight: (index + 1) % 5 !== 0 ? "26.25px" : "0",
                                    }}
                                    key={index}>
                                    <PurchaseHistoryOrderCodesItem
                                        name={item.name}
                                        price={item.price}
                                        discount={item.discount}
                                        place={item.place}
                                        image={item.image}
                                        orderTime={item.orderTime}
                                        paidStatus={item.paidStatus}
                                    />
                                </div>
                            )
                        })
                    }
                </div>
                {
                    totalPages > 1 && (
                        <div className="purchaseHistoryOrderCodesList__container-items-pagination">
                            <div className="purchaseHistoryOrderCodesList__container-items-pagination-wrap">
                                <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={(e, page) => {
                                        handlePageChange(page)
                                        scrollToTop();
                                    }}
                                    shape="rounded"
                                    style={{
                                        color: "#3A3A3A",
                                        backgroundColor: "#fff",
                                        borderRadius: "5px",
                                        padding: "5px",
                                        border: "none",
                                        paddingLeft: currentPage === 1 ? "38px" : "0",
                                        paddingRight: currentPage === totalPages ? "38px" : "0",
                                    }}
                                    hidePrevButton={currentPage === 1}
                                    hideNextButton={currentPage === totalPages}
                                />
                            </div>
                        </div>
                    )
                }
            </div>

         */
        
        return (
            <div className="purchaseHistoryOrderCodesList__container_data_map">
                <div className="purchaseHistoryOrderCodesList__container_data_map_items">
                    {
                        paginatedData.map((item: any, index: number) => {
                            console.log("item: ", item);
                            return (
                              <OrderCodesItem
                                key={index}
                                item={item}
                                isDineIn={item && item.dineInAdId!}
                              />
                                //<div
                                //    style={{
                                //        marginTop: "20px",//(index + 1) % 5 !== 0 ? "20px" : "0",
                                //        //marginLeft: (index + 1) % 5 !== 1 ? "30px" : "0",
                                //        marginRight: (index + 1) % 5 !== 0 ? "26.25px" : "0",
                                //    }}
                                //    key={index}>
                                    /* {/!* <PurchaseHistoryOrderCodesItem
                                      item={item}
                                      isDineIn={item && item.dineInAdId!}
                                    /> *!/} */
                                    
                                    //<OrderCodesItem
                                    //  key={index}
                                    //  item={item}
                                    //  isDineIn={item && item.dineInAdId!}
                                    ///>
                                //</div>
                            )
                        })
                    }
                </div>
                {
                    totalPages > 1 && (
                        <div className="purchaseHistoryOrderCodesList__container_data_map_items_pagination">
                            <div className="purchaseHistoryOrderCodesList__container_data_map_items_pagination_content">
                                <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={(e, page) => {
                                        handlePageChange(page)
                                        scrollToTop();
                                    }}
                                    shape="rounded"
                                    style={{
                                        color: "#3A3A3A",
                                        backgroundColor: "#fff",
                                        borderRadius: "5px",
                                        padding: "5px",
                                        border: "none",
                                        paddingLeft: currentPage === 1 ? "38px" : "0",
                                        paddingRight: currentPage === totalPages ? "38px" : "0",
                                    }}
                                    hidePrevButton={currentPage === 1}
                                    hideNextButton={currentPage === totalPages}
                                />
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }

    /*
            <div className="purchaseHistoryOrderCodesList__container">
            <div className="purchaseHistoryOrderCodesList__container_content">
                <div className="purchaseHistoryOrderCodesList__container_content-category-wrap">
                    <div
                        className={`purchaseHistoryOrderCodesList__container_content-category all
                        ${selectedCategory === "All" ? "active" : ""}
                        ${category === "all" ? 'active' : ''}
                        `}
                        onClick={() => {
                            setSelectedCategory("All");
                            props.handleSelectCategory("All");
                            navigate(`/my-codes/purchase-history/all`);
                        }}
                    >
                        <span>All</span>
                    </div>
                    {
                        props.userOrderData.map((item: any, index: number) => (
                            <div
                                key={index}
                                className={`purchaseHistoryOrderCodesList__container_content-category
                                ${selectedCategory === item.subcategory ? "active" : ""}`}
                                onClick={() => {
                                    setSelectedCategory(item.subcategory);
                                    props.handleSelectCategory(item.subcategory);
                                    navigate(`/my-codes/purchase-history/${item.subcategory.toLowerCase().replace(/\s/g, "-")}`);
                                }}
                            >
                                <span>{item.subcategory}</span>
                            </div>
                        ))
                    }
                </div>
                <div className="purchaseHistoryOrderCodesList__container-wrap">
                    {
                        renderProductByCategory()
                    }
                </div>
            </div>
        </div>

     */
    
    return (
        <div className="purchaseHistoryOrderCodesList__container">
        <div className="purchaseHistoryOrderCodesList__container_content">
            <div className="purchaseHistoryOrderCodesList__container_content_categories">
                <div
                    className={`purchaseHistoryOrderCodesList__container_content_categories_category all
                    ${selectedCategory === "All" ? "active" : ""}
                    ${category === "all" ? 'active' : ''}
                    `}
                    onClick={() => {
                        setSelectedCategory("All");
                        props.handleSelectCategory("All");
                        navigate(`/my-codes/purchase-history/all`);
                    }}
                >
                    <span>All</span>
                </div>
                {
                    props.userOrderData.map((item: any, index: number) => (
                        <div
                            key={index}
                            className={`purchaseHistoryOrderCodesList__container_content_categories_category
                            ${selectedCategory === item?.takeOutAdId?.tags[0] ? "active" : ""}`}
                            onClick={() => {
                                setSelectedCategory(item?.takeOutAdId?.tags[0] || '');
                                props.handleSelectCategory(item?.takeOutAdId?.tags[0] || '');
                                navigate(`/my-codes/purchase-history/${(item?.takeOutAdId?.tags[0] || 'All').toLowerCase().replace(/\s/g, "-")}`);
                            }}
                        >
                            <span>{item?.takeOutAdId?.tags[0] || ''}</span>
                        </div>
                    ))
                }
            </div>
            <div className="purchaseHistoryOrderCodesList__container_data">
                {
                    renderProductByCategory()
                }
            </div>
        </div>
    </div>
    );
};

export default PurchaseHistoryOrderCodesList;